/**
 * Opaque, stable code for a logical API route — what PostHog gets instead of
 * the route itself, because analytics payloads are readable in DevTools.
 *
 * Must match backend/src/utils/tunnelRouteCode.js (same id collapsing, same
 * hash), which logs the code as `route_code` on every tunnelled request so a
 * code can be looked up in Loki. __tests__/lib/tunnelFetch.test.js checks the
 * two against each other.
 */
export const normalizeRoute = (path) =>
  String(path || "")
    .split("?")[0]
    .split("/")
    .map((segment) => {
      if (/^[0-9a-f]{24}$/i.test(segment) || /^[0-9a-f]{32}$/i.test(segment)) return ":id";
      if (/^[0-9a-f-]{36}$/i.test(segment)) return ":uuid";
      if (/^\d+$/.test(segment)) return ":n";
      return segment;
    })
    .join("/");

export const routeCode = async (path) => {
  const digest = await crypto.subtle.digest(
    "SHA-256",
    new TextEncoder().encode(normalizeRoute(path)),
  );
  return Array.from(new Uint8Array(digest).subarray(0, 4), (b) =>
    b.toString(16).padStart(2, "0"),
  ).join("");
};
